import React from "react";

const RoleBadge: React.FC<{ role: "admin" | "editor" | "viewer" }> = ({ role }) => (
  <span
    className={`inline-block px-2 py-0.5 text-xs font-medium rounded ${
      role === "admin"
        ? "bg-purple-100 text-purple-700"
        : role === "editor"
        ? "bg-blue-100 text-blue-700"
        : "bg-gray-100 text-gray-700"
    }`}
  >
    {role}
  </span>
);

export default RoleBadge;
